import React, { useEffect } from "react";
import { MDBDataTableV5 } from "mdbreact";
import { Button, TableContainer } from "../../../styles";
import { ICON_BIN, ICON_PEN, ICON_PLUS } from "../../../utils/icons";
import DeleteModal from "../DeleteModal";
import { useState } from "react";
import AddItem from "./AddItem";
import EditItem from "./EditItem";
import { useAuthContext } from "../../../context/auth_context";
import { useItemContext } from "../../../context/item_context";
import MiniLoader from "../../../utils/MIniLoader";
import { useUserContext } from "../../../context/user_context";
import { placeholder } from "../../../assets";
import CustomTable from "../../../utils/CustomTable";

export default function AllItems() {

      const [itemData, setItemData] = useState('');

      const {
            getFeature: { checkFeature }
      } = useAuthContext();

      const {
            openAddItem,
            openEditItem,
            itemLoading, getItemData, allItems
      } = useItemContext();

      const { btoken, stoken } = useUserContext();


      function openEditModal(item) {
            setItemData(item);
            openEditItem();
      }


      useEffect(() => {
            const item = allItems?.map((item, i) => {

                  const { id, icid, item: item_name, details, real_date, supplier, category, type, sid, image } = item;

                  const payload = { btoken, stoken, itemId: id };
                  return (
                        {
                              sn: i + 1,
                              id,
                              real_date,
                              image: <img src={image || placeholder} alt={item_name} width="50px" className="br-md" />,
                              item_name,
                              category,
                              details,
                              supplier: supplier || 'Nil',
                              sid,
                              // timeago: timeago,

                              action:
                                    // checkFeature('item_edit') &&
                                    //       <>
                                    //       </>
                                    <h6 className="d-flex fit-content  border-bottom pointer border-success green-text text-center"
                                          onClick={(e) => openEditModal(item)}
                                    >
                                          {ICON_PEN}
                                    </h6>
                              ,
                              delete:
                                    <DeleteModal
                                          payload={payload}
                                          name={item_name}
                                          url={'deleteItem'}
                                          getDataFn={getItemData}
                                          dataName={'Item'}
                                    >
                                          <h6 className="d-flex fit-content  border-bottom pointer border-danger red-text text-center"
                                          >
                                                {ICON_BIN}
                                          </h6>
                                    </DeleteModal>
                              // checkfeature('item_delete') &&


                        }
                  );
            });

            setDatatable({
                  ...datatable,
                  // columns: [
                  //       {
                  //             label: checkfeature('item_edit') ? 'Action' : '',
                  //             label: 'Action',
                  //             field: "action",
                  //             width: 200,
                  //       },
                  //       {
                  //             label: checkfeature('item_delete') ? 'Delete' : '',
                  //             label: 'Delete',
                  //             field: "delete",
                  //             width: 200,
                  //       },
                  // ],
                  rows:
                        item
            });
      }, [allItems]);

      useEffect(() => {
            getItemData();
      }, []);


      const [datatable, setDatatable] = React.useState({
            columns: [
                  {
                        label: "S/N",
                        field: "sn",
                        width: 150,
                        attributes: {
                              "aria-controls": "DataTable",
                              "aria-label": "sn",
                        },
                  },
                  {
                        label: "ID",
                        field: "id",
                        width: 150,
                  },
                  {
                        label: "Date Added",
                        field: "real_date",
                        width: 150,
                  },
                  {
                        label: "Image",
                        field: "image",
                        width: 270,
                  },
                  {
                        label: "Item",
                        field: "item_name",
                        width: 270,
                  },
                  {
                        label: "Category",
                        field: "category",
                        width: 270,
                  },
                  {
                        label: "Details",
                        field: "details",
                        width: 270,
                  },
                  {
                        label: "Supplier",
                        field: "supplier",
                        width: 270,
                  },
                  {
                        label: checkFeature('item_edit') ? 'Action' : '',
                        label: 'Action',
                        field: "action",
                        width: 200,
                  },
                  {
                        label: checkFeature('item_delete') ? 'Delete' : '',
                        label: 'Delete',
                        field: "delete",
                        width: 200,
                  },
            ],
            rows: []
      });


      return (
            <>

                  <div className="">

                        <CustomTable
                              tableTitle={"All Items"}
                              loading={itemLoading}
                              getData={getItemData}
                              openAddModal={openAddItem}
                              addTitle={"Add Item"}
                              datatable={datatable}
                        />

                  </div>

                  {/* Add Item Modal */}
                  <AddItem />
                  {/* Add Item Modal */}

                  {/* Edit Item Modal */}
                  <EditItem
                        {...itemData}
                  />
                  {/* Edit Item Modal */}
            </>

      );
}
